import { ReactComponent as Explanation } from '@svgs/explanation.svg';
import { ReactComponent as Match } from '@svgs/match.svg';
import { ReactComponent as Reward } from '@svgs/reward.svg';
import { ReactComponent as Scenario } from '@svgs/scenario.svg';
import { ReactComponent as Side } from '@svgs/side.svg';
import { ReactComponent as Situation } from '@svgs/situation.svg';
import { ReactComponent as Sort } from '@svgs/sort.svg';
import { ReactComponent as Test } from '@svgs/test.svg';
import { ReactComponent as Theory } from '@svgs/theory.svg';

// situation, scenario, card_form_activity, match_activity, theory, article
export const actionButtonLayoutByVariant = {
  article: {
    svg: Theory,
  },
  card_form_activity: {
    svg: Explanation,
  },
  choose_correct_side_activity: {
    svg: Side,
  },
  match_activity: {
    svg: Match,
  },
  reward: {
    svg: Reward,
  },
  scenario: {
    svg: Scenario,
  },
  situation: {
    svg: Situation,
  },
  sorting_activity: {
    svg: Sort,
  },
  test: {
    svg: Test,
  },
  theory: {
    svg: Theory,
  },
};
